export default {
  API: 'https://admin-api.yuntongbao.cn', //后台API
  //API: 'http://localhost:10011', //后台API
  mapKey: '', //腾讯地图key
}